import { z } from 'zod'

/**
 * The VAT rate field of a dish or a topping: a percentage the owner types as
 * "8", "8,5" or "23 %", or leaves empty. Within the API's bounds, 0 to 100
 * with at most two decimals, so a value the server would refuse never leaves
 * the form. An emptied field is no rate, not an error: the inner optional
 * catches the undefined the cleaning turns it into.
 */
export const taxRateValidationSchema = z
  .preprocess(val => {
    if (typeof val === 'string') {
      const cleaned = val.replace(',', '.').replace(/[^0-9.]+/g, '')
      return cleaned === '' ? undefined : Number(cleaned)
    }
    if (typeof val === 'number') return val
    return undefined
  }, z.number().min(0).max(100).multipleOf(0.01).optional())
  .optional()
